import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Candle } from "@/components/Candle";
import { Loader2, CheckCircle2 } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [status, setStatus] = useState("checking");
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = params.get("session_id");
    if (!sessionId) { navigate("/"); return; }

    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const res = await api.get(`/payments/status/${sessionId}`);
        if (res.data.payment_status === "paid") {
          const candleId = res.data.candle_id;
          try { await api.post(`/candles/${candleId}/confirm`, { session_id: sessionId }); } catch (e) {}
          setStatus("paid");
          setTimeout(() => navigate(`/candle/${candleId}`), 1600);
          return;
        }
      } catch (e) { /* keep polling */ }
      if (attempts >= 12) { setStatus("timeout"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, [params, navigate]);

  return (
    <div className="flex h-[100dvh] flex-col items-center justify-center bg-black px-6 text-center">
      <Candle progress={1} size={260} />
      {status === "checking" && (
        <>
          <Loader2 className="mt-4 animate-spin text-sky-400" />
          <p className="mt-3 text-muted-foreground">{t("payment.confirming")}</p>
        </>
      )}
      {status === "paid" && (
        <>
          <CheckCircle2 className="mt-4 text-emerald-400" size={36} />
          <p className="mt-3 font-medium">{t("payment.flameLit")}</p>
          <p className="text-sm text-muted-foreground">{t("payment.redirecting")}</p>
        </>
      )}
      {status === "timeout" && (
        <p className="mt-4 text-muted-foreground">{t("payment.timeout")}</p>
      )}
    </div>
  );
}
